import { useEffect } from "react";
import {
  Flex,
  Text,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Stack,
  Select,
} from "@chakra-ui/react";
import { AddIcon } from '@chakra-ui/icons';
import { useForm, Controller } from 'react-hook-form';

export default function ModalAddPayment({

    //prop
    listPaymentMethods = [],
    isDisable = true ,
    totalAmount = 0,
    // event
    onAddPayment
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    onAddPayment(data.payment_method);
    reset();
    onClose();
  };
  useEffect(() => {
    if (!isOpen) {
        // setValue('amount', '');
        reset();
        return;
    }
     setValue('amount', totalAmount.toLocaleString("en-US"));
  }, [isOpen]);
  return (
    <>
      <Button
        size="sm"
        onClick={onOpen}
        leftIcon={<AddIcon />}
        colorScheme="blue"
        variant="outline"
        disabled={isDisable}
      >
        Add Payment
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>Add Payment</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl isInvalid={errors.amount} mb={4}>
              <FormLabel>Total amount</FormLabel>
              <Input
                placeholder="Enter the amount"
                {...register('amount')}
                readOnly
              />
              <Text color="red.500" fontSize="sm">
                {errors.amount?.message}
              </Text>
            </FormControl>
            <FormControl isInvalid={errors.payment_method}>
              <FormLabel>Payment method</FormLabel>
              <Controller
                name="payment_method"
                control={control}
                rules={{ required: 'Select the payment method' }}
                render={({ field }) => (
                  <Select placeholder="Select the method" {...field}>
                    {listPaymentMethods.length > 0 && listPaymentMethods.map((method, i) => (
                      <option key={i} value={method.id}>
                        {method.name}
                      </option>
                    ))}
                  </Select>
                )}
              />
              <Text color="red.500" fontSize="sm">
                {errors.payment_method?.message}
              </Text>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} type="submit">
              Add
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
